<template>
    <vue100vh style="position: fixed; width: -webkit-fill-available;">
      <v-main>
        <v-container fluid class="pl-0 pr-0 pt-0 pb-0">
          <v-toolbar style="background-color: white !important;">
            <v-btn icon @click="toPage('/task/homepage')">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('HeaderMenubar.createproject') }}</v-toolbar-title>
          </v-toolbar>
          <v-layout row wrap class="mt-2 ml-4 mr-4 layout-height" v-if="progress" justify-center align-center>
            <v-progress-circular size="80" :indeterminate="progress" color="primary"></v-progress-circular>
          </v-layout>
          <v-flex sm12 xs12 class="chatboxnonselect layout-height height-100vh" v-else>
            <v-main>
              <v-container fluid fill-height class="scrolling-wrapper">
                <v-stepper vertical v-model="stepSelect"
                  style="width: -webkit-fill-available !important; margin-top: 10px !important;">
                  <v-stepper-header>
                    <v-stepper-step :complete="stepSelect > 1" step="1">
                      {{ $t('Task.create.placeholderSubjectProject') }}
                    </v-stepper-step>
  
                    <v-divider></v-divider>
  
                    <v-stepper-step :complete="stepSelect > 2" step="2">
                      {{ $t('Task.create.select') }}
                    </v-stepper-step>
                  </v-stepper-header>
  
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card class="mb-12" color="lighten-1" height="400px">
                        <v-layout column justify-center class="mt-2" style="height: 280px;">
                          <template>
                            <v-flex class="layoutfield">
                              <v-text-field name="projectname" :label="$t('Task.create.placeholderSubjectProject')"
                                id="id" v-model="project_name" solo></v-text-field>
                            </v-flex>
                            <v-flex class="layoutfield">
                              <v-textarea :label="$t('Task.create.description')" name="descriptionproject" no-resize solo
                                v-model="detail_project" :rules="[(v) => v.length <= 250 || '']"
                                :counter="250"></v-textarea>
                            </v-flex>
                          </template>
                        </v-layout>
                      </v-card>
                      <v-btn small class="btnclear" @click="cancel_project()">{{ $t('AnswerQuestion.clear') }}</v-btn>
                      <v-btn dark small class="btncreate" @click="stepSelect = 2"
                        :disabled="project_name == ''">{{ $t('Task.allTask.next') }}</v-btn>
                    </v-stepper-content>
  
                    <v-stepper-content step="2" class="pt-0">
                      <v-card class="mb-12" color="lighten-1" height="500px">
                        <v-layout row wrap class="mt-0">
                          <v-flex sm12 md12 xl12 lg12>
                            <v-tabs left color="white" icons-and-text v-model="tabs" class="mt-2">
                              <v-tabs-slider color="#232b35"></v-tabs-slider>
  
                              <v-tab :key="1" href='#tab-1'>
                                <p style="color: #232b35; text-transform: none;">{{ $t('LeftSide.friend.friend') }}</p>
                                <v-icon small color="#232b35">fas fa-user</v-icon>
                              </v-tab>
  
                              <v-tab :key="2" href='#tab-2'>
                                <p style="color: #232b35; text-transform: none;">{{ $t('LeftSide.friend.group') }}</p>
                                <v-icon small color="#232b35">fas fa-users</v-icon>
                              </v-tab>
                              <v-tabs-items v-model="tabs">
                                <v-tab-item id="tab-1" class="ml-5">
                                  <v-row v-if="listfriend.length !== 0" class="mr-1">
                                    <v-col cols="12" class="mt-3">
                                      <v-text-field v-model="search" solo
                                        :label="$t('Task.allTask.placeholderSearchFriend')" clearable
                                        append-icon="mdi-magnify" hide-details></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-layout v-if="FilterListFriend.length === 0" class="justify-center align-center">
                                    <v-col cols="12" v-if="search === '' || search === null" align="center" class="mt-2">
                                      <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                                      <h4 class="mt-3">{{ $t('Task.allTask.noListFriend') }}</h4>
                                    </v-col>
                                    <v-col cols="12" v-else align="center" class="mt-2">
                                      <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                                      <h4 class="mt-3">{{ $t('LeftSide.noDataSearching') }}</h4>
                                    </v-col>
                                  </v-layout>
                                  <v-row v-else>
                                    <v-col cols="12" class="mt-0 pt-0">
                                      <div style="min-height: 0; height: 390px !important;"
                                        class="scrolling-wrapper">
                                        <!-- height: calc(100vh - 350px) !important; -->
                                        <v-list flat>
                                          <v-list-item-group mandatory>
                                            <template v-for="(item, index) in FilterListFriend">
                                              <v-list-item :key="`${index}-${item.tokenroom}`"
                                                @click.native="radios = item.tokenroom">
                                                <template v-slot:default="{ active }">
                                                  <v-list-item-action>
                                                    <v-radio-group v-model="radios" :mandatory="false">
                                                      <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                                    </v-radio-group>
                                                  </v-list-item-action>
                                                  <v-list-item-avatar>
                                                    <v-img :alt="`${item.name} avatar`" :src="item.profilepicture"
                                                      v-if="item.profilepicture" class="object-fit-img"></v-img>
                                                    <img :src="`${publicPath}/assets/img/default_profile/man-white.png`"
                                                      class="object-fit-img" v-else-if="item.type == 'user'"
                                                      :alt="`${item.name} avatar`">
                                                    <img :src="`${publicPath}/assets/img/default_profile/bot-white.png`"
                                                      class="object-fit-img" v-else-if="item.type == 'bot'"
                                                      :alt="`${item.name} avatar`">
                                                    <img
                                                      :src="`${publicPath}/assets/img/default_profile/business-white.png`"
                                                      class="object-fit-img" v-else-if="item.type == 'business'"
                                                      :alt="`${item.name} avatar`">
                                                    <img :src="`${publicPath}/assets/img/default_profile/man-white.png`"
                                                      class="object-fit-img" v-else :alt="`${item.name} avatar`">
                                                  </v-list-item-avatar>
                                                  <v-list-item-content>
                                                    <v-list-item-title class="ml-3">{{ item.name }}</v-list-item-title>
                                                  </v-list-item-content>
                                                </template>
                                              </v-list-item>
                                              <v-divider v-if="index < FilterListFriend.length - 1"
                                                :key="index"></v-divider>
                                            </template>
                                          </v-list-item-group>
                                        </v-list>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-tab-item>
                                <v-tab-item id="tab-2" class="ml-5">
                                  <v-row v-if="listfriend.length !== 0" class="mr-1">
                                    <v-col cols="12" class="mt-3">
                                      <v-text-field v-model="search_group" solo
                                        :label="$t('Task.allTask.placeholderSearchGroup')" clearable
                                        append-icon="mdi-magnify" hide-details></v-text-field>
                                    </v-col>
                                  </v-row>
                                  <v-layout v-if="FilterListGroup.length === 0" class="justify-center align-center">
                                    <v-col cols="12" v-if="search_group === '' || search_group === null" align="center"
                                      class="mt-2">
                                      <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                                      <h4 class="mt-3">{{ $t('Task.allTask.noListGroup') }}</h4>
                                    </v-col>
                                    <v-col cols="12" v-else align="center" class="mt-2">
                                      <v-icon style="font-size: 60px !important;">fas fa-user-friends</v-icon>
                                      <h4 class="mt-3">{{ $t('LeftSide.noDataSearching') }}</h4>
                                    </v-col>
                                  </v-layout>
                                  <v-row v-else>
                                    <v-col cols="12" class="mt-0 pt-0">
                                      <div style="min-height: 0; height: 380px !important;"
                                        class="scrolling-wrapper">
                                        <!-- height: calc(100vh - 380px) !important; -->
                                        <v-list flat>
                                          <v-list-item-group mandatory>
                                            <template v-for="(item, index) in FilterListGroup">
                                              <v-list-item :key="`${index}-${item.tokenroom}`"
                                                @click.native="radios = item.tokenroom">
                                                <template v-slot:default="{ active }">
                                                  <v-list-item-action>
                                                    <v-radio-group v-model="radios" :mandatory="false">
                                                      <v-radio :value="item.tokenroom" class="radioPosition"></v-radio>
                                                    </v-radio-group>
                                                  </v-list-item-action>
                                                  <v-list-item-avatar>
                                                    <v-img :alt="`${item.name} avatar`" :src="item.picture"
                                                      v-if="item.picture" class="object-fit-img"></v-img>
                                                    <img :src="`${publicPath}/assets/img/default_profile/group-white.png`"
                                                      class="object-fit-img" v-else :alt="`${item.name} avatar`">
                                                  </v-list-item-avatar>
                                                  <v-list-item-content>
                                                    <v-list-item-title class="ml-3">{{ item.name }}</v-list-item-title>
                                                  </v-list-item-content>
                                                </template>
                                              </v-list-item>
                                              <v-divider v-if="index < FilterListGroup.length - 1"
                                                :key="index"></v-divider>
                                            </template>
                                          </v-list-item-group>
                                        </v-list>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-tab-item>
                              </v-tabs-items>
                              <v-layout row wrap align-center class="ml-1 mr-5 bg-white" v-if="tabs == 'tab-1'">
                                <v-flex class="mt-2" v-if="listfriend.length == 0">
                                  <v-btn small dark class="btncreate"
                                    @click="open_add_friend()">{{ $t('LeftSide.friend.addFriend') }}</v-btn>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap align-center justify-end class="ml-1 mr-5 bg-white" v-else>
                                <v-btn small dark class="btncreate"
                                  @click="open_create_group()">{{ $t('Task.allTask.newGroup') }}</v-btn>
                              </v-layout>
                            </v-tabs>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-row class="ma-3">
                        <v-btn small class="btncancle" @click="stepSelect = 1">{{ $t('Register.Button.back') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn dark small style="margin-right: 60px;" class="btnclear"
                          @click="cancel_radios()">{{ $t('AnswerQuestion.clear') }}</v-btn>
                        <v-btn dark small class="btncreate" @click="create_project = 'isloading'" :loading="isloading"
                          :disabled="project_name == '' || radios == ''">{{ $t('AnswerQuestion.ok') }}</v-btn>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-container>
            </v-main>
          </v-flex>
        </v-container>
  
      <CreateGroupDialog :CreatedGroupDialog="CreatedGroupDialog" @closeDialog="closeDialog" @updatecreategroup="updatecreategroup"></CreateGroupDialog>
      <AddDialog :AddFriendDialog="AddFriendDialog" @closeDialog="closeDialog" @blockevent="blockevent"></AddDialog>
      </v-main>
    </vue100vh>
  </template>
  
  <script>
  import { sync } from 'vuex-pathify'
  import { Momenttime } from '@/services'
  import CreateGroupDialog from '@/components/dialog/CreatedGroupDialog'
  import AddDialog from '@/components/dialog/AddFriendDialog'
  import vue100vh from 'vue-100vh'
  
  var _ = require('lodash')
  export default {
    components: {
      CreateGroupDialog,
      AddDialog,
      vue100vh
    },
    data() {
      return {
        publicPath: process.env.VUE_APP_BASE_PATH,
        AddFriendDialog: false,
        radios: '',
        tabs: '',
        text: 'mm',
        listproject: [],
        dialogDetailTask: false,
        dialogCreateProject: false,
        status_login: '',
        windowWidth: '',
        mini: true,
        dialog: false,
        drawer: true,
        detail: {},
        token: '',
        detail_project: {},
        progress: false,
        projectid: '',
        state_id: '',
        member: [],
        taskid: '',
        search: '',
        search_group: '',
        listproject_user: [],
        listproject_group: [],
        listfriend: [],
        listgroup: [],
        project_name: '',
        detail_project: '',
        isloading: false,
        CreatedGroupDialog: false,
        stepSelect: 1,
        create_project: null,
        data_user: {},
      }
    },
    mounted() {
      // this.$nextTick(() => {
      //   window.addEventListener('resize', () => {
      //     this.windowWidth = window.innerWidth
      //   })
      // })
    },
    created() {
      // var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      // this.token = decoded['tokenuser']
      // this.status_login = decoded['status_login']
      var user_profile = ''
      if (JSON.parse(this.$cookie.get('user-profile') == null)) {
        user_profile = JSON.parse(localStorage.getItem('user-profile'))
      } else {
        user_profile = JSON.parse(this.$cookie.get('user-profile'))
      }
      this.data_user = user_profile['account']['profile']
      this.token = this.data_user.tokenuser
      this.get_list_friend()
      this.get_list_group()
    },
    computed: {
      ...sync('*'),
      pages() {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0
  
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      },
      FilterListFriend() {
        if (this.search !== '' && this.search !== null) {
          return this.listfriend.filter(post => {
            return post.name.toLowerCase().includes(this.search.toLowerCase())
          })
        } else {
          return this.listfriend
        }
      },
      FilterListGroup() {
        if (this.search_group !== '' && this.search_group !== null) {
          return this.listgroup.filter(post => {
            return post.name.toLowerCase().includes(this.search_group.toLowerCase())
          })
        } else {
          return this.listgroup
        }
      }
    },
    watch: {
      windowWidth() {
        if (this.windowWidth <= 960) {
          this.$router.push('/mobile/homepage')
        }
      },
      create_project() {
        const l = this.create_project
        this[l] = true
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/create_project', {
          tokenuser: this.token,
          tokenroom: this.radios,
          project_name: this.project_name,
          detail: this.detail_project
        }).then((response) => {
          if (response.data.status === 'success') {
            // console.log(response.data.data)
            this[l] = false
            this.cancel_project()
            this.$swal('', this.$t('Alert.Success.createProject'), 'success')
            this.projectid = response.data.data._id
            this.$router.push('/task/' + this.projectid + '/' + response.data.data.tokenroom)
          }
        }).catch(error => {
          console.log(error.message)
        })
      },
      socketmessage(data) {
        // console.log(data)
        if (data.tokenuser !== this.token) {
          if (data.message == 'create_task') {
            this.get_task_by_id(data.task_id, data.state.state_id, 'create')
          }
        }
      },
      socket_deletetask(data) {
        // console.log(data)
        if (data.tokenuser !== this.token) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
            tokenuser: this.token,
            tokenroom: this.$route.params.roomid,
            project_id: this.projectid
          }).then((responsed) => {
            // console.log(responsed.data.data)
            if (responsed.data.status == 'success') {
              this.detail_project = responsed.data.data
            }
          })
        }
      },
      socket_edittask(data) {
        // console.log(data)
        if (data.tokenuser !== this.token) {
          this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
            tokenuser: this.token,
            task_id: data.task_id
          }).then((responsed) => {
            if (responsed.data.status == 'success') {
              // console.log(responsed.data.data)
              var new_state = responsed.data.data.state.id
              var old_index = ''
              var index_member = ''
              var index = ''
              old_index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == data.state_id.id })
              index_member = _.findIndex(this.detail_project.state[old_index].member, function (o) { return o._id == data.task_id })
              index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == new_state })
              this.detail_project.state[old_index].member.splice(index_member, 1)
              this.detail_project.state[index].member.unshift(responsed.data.data)
            }
          })
        }
      },
      socketaccept_friend(data) {
        var tokenfriend = data.tokenfriend
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/searchtokenuser', { tokenuser: this.token, tokenfriend: tokenfriend }).then((response) => {
          if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
            this.listfriend.unshift(response.data.user)
            this.radios = ''
          }
        })
      },
      socketremove_friend(data) {
        // console.log(data)
        var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
        if (index >= 0) {
          this.listfriend.splice(index, 1)
        }
      },
      block_friend(data) {
        this.blockevent(data)
      }
    },
    methods: {
      blockevent(data) {
        // console.log(data)
        if (data.event === 'unblock_friend') {
          this.listfriend.push(data)
        }
      },
      open_add_friend() {
        this.AddFriendDialog = true
      },
      open_create_group() {
        this.CreatedGroupDialog = true
        console.log("open_create_group", this.CreatedGroupDialog)
      },
      // closeDialogCreateGroup(value) {
      //   this.CreateGroup = value
      // },
      closeDialog(value) {
        this.AddFriendDialog = value
        this.CreatedGroupDialog = value
        this.get_list_friend()
        this.get_list_group()
      },
      updatecreategroup(data, filename) {
        if (_.find(this.listgroup, function (o) { return o.group_id === data.group_id }) === undefined) {
          this.listgroup.unshift({
            count_read: '',
            create_date: data.create_date,
            group_id: data.group_id,
            member: data.member,
            name: data.name,
            picture: filename,
            state: data.state,
            timestamp: data.timestamp,
            tokenroom: data.tokenroom,
            type: data.type
          })
          this.listgroup = _.reverse(_.sortBy(this.listgroup, function (dateObj) {
            return new Date(dateObj.create_date)
          }))
        }
      },
      cancel_project() {
        this.project_name = ''
        this.detail_project = ''
        // this.radios = ''
      },
      cancel_radios() {
        this.radios = ''
      },
      get_list_friend() {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistfriend', {
          tokenuser: this.token
        }).then((response) => {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.listfriend = response.data['listfriend']
            // this.listfriend = []
            // console.log(this.listfriend)
          }
        }).catch(error => {
          console.log(error.message)
        })
      },
      get_list_group() {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistgroup', {
          tokenuser: this.token
        }).then((response) => {
          if (response.data.status === 'success') {
            this.progress = false
            this.listgroup = response.data['listgroup']
            // console.log(this.listgroup)
            this.listgroup = _.reverse(_.sortBy(this.listgroup, function (dateObj) {
              return new Date(dateObj.create_date)
            }))
          }
        }).catch(error => {
          console.log(error.message)
        })
      },
      toPage(path) {
        this.$router.push(path)
      },
      topage_task(projectid, tokenroom) {
        // console.log(projectid)
        this.$router.push('/mobile/task/' + projectid + '/' + tokenroom)
      },
      momentday(timestamp) {
        return Momenttime.momentdatethai(timestamp)
      },
      createdproject(value) {
        this.get_project_by_id(value.project_id, value.event)
      },
      closeCreateProject(value) {
        this.dialogCreateProject = value
      },
      edittask(data) {
        // console.log(data)
        this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
      },
      deletetask(data) {
        // console.log(data)
        var index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == data.state_id })
        var index_member = _.findIndex(this.detail_project.state[index].member, function (o) { return o._id == data.task_id })
        this.detail_project.state[index].member.splice(index_member, 1)
      },
      closeDetailTask(value) {
        this.dialogDetailTask = value
      },
      open_create_project() {
        this.dialogCreateProject = true
      },
      open_detail_task(taskid) {
        this.taskid = taskid
        // console.log(this.StateId)
        this.dialogDetailTask = true
      },
      toChatroom() {
        // this.$router.push('/chat/room/' + this.$route.params.roomid)
        this.$router.go(-1)
      },
      get_data_room() {
        this.detail = {}
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.detail = response.data
            // console.log(this.detail)
            var member = []
            member = response.data.data_room
            this.member = _.filter(member, function (o) { return o.statemember == 'active' })
            // this.check_project_room()
          }
        })
      },
      get_project_room() {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_tokenuser', {
          tokenuser: this.token
        }).then((response) => {
          // console.log(response.data.data)
          if (response.data.status === 'success') {
            this.progress = false
            this.listproject = response.data.data
            this.listproject = _.reverse(_.sortBy(this.listproject, function (dateObj) {
              return new Date(dateObj.timestamp)
            }))
            this.listproject_group = _.filter(this.listproject, function (o) { return o.tokenroom.startsWith('G') })
            this.listproject_user = _.filter(this.listproject, function (o) { return o.tokenroom.startsWith('R') })
            // console.log(this.listproject_group)
            // console.log(this.listproject_user)
          }
        }).catch(error => {
          console.log(error.message)
        })
      },
      // created_project () {
      //   this.isLoading = true
      //   this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/create_project', {
      //     tokenuser: this.token,
      //     tokenroom: this.radios,
      //     project_name: this.project_name,
      //     detail: this.detail_project
      //   }).then((response) => {
      //     if (response.data.status === 'success') {
      //       // console.log(response.data.data)
      //       this.isLoading = false
      //       this.cancel_project()
      //       this.$swal('', this.$t('Alert.Success.createProject'), 'success')
      //       this.projectid = response.data.data._id
      //       this.$router.push('/mobile/task/' + this.projectid + '/' + response.data.data.tokenroom)
      //     }
      //   }).catch(error => {
      //     console.log(error.message)
      //   })
      // },
      get_project_by_id(projectid, events) {
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: projectid
        }).then((responsed) => {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            if (events == 'create_project') {
              this.listproject.unshift(responsed.data.data)
            }
          }
        }).catch(error => {
          console.log(error.message)
        })
      },
      get_task_by_id(taskid, stateid, stateevent, oldstate) {
        this.axios.post(process.env.VUE_APP_API_EVENT + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: taskid
        }).then((responsed) => {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var old_index = ''
            var index_member = ''
            var index = ''
            if (stateevent == 'edit') {
              old_index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == oldstate })
              index_member = _.findIndex(this.detail_project.state[old_index].member, function (o) { return o._id == taskid })
              index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == stateid })
              this.detail_project.state[old_index].member.splice(index_member, 1)
              this.detail_project.state[index].member.unshift(responsed.data.data)
              // console.log(this.detail_project.state[index].member)
            } else if (stateevent == 'create') {
              index = _.findIndex(this.detail_project.state, function (o) { return o.state_id == stateid })
              this.detail_project.state[index].member.unshift(responsed.data.data)
            }
          }
        })
      }
    }
  }
  </script>
  <style type="text/css" scoped>
  /* >>>.v-stepper__content {
    height: 380px !important;
  } */
  /* >>>.v-stepper__wrapper {
    height: 340px !important;
  } */
  >>>.v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none !important;
  }
  
  .scrolling-wrapper {
    /*display: flex;*/
    overflow-y: auto;
  }
  
  .scrolling-wrapper::-webkit-scrollbar {
    height: 4px;
    width: 8px;
  }
  
  .scrolling-wrapper::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background: rgba(0, 0, 0, .1);
  }
  
  .listFrinend {
    width: 100%;
    height: 80%;
    background-color: transparent;
    color: white;
  }
  
  .cardOfFriendList {
    margin: 5px 5px 5px 5px;
    border-radius: 10px;
    /* background-color: #AC8887 !important; */
    border: #92ADCF solid 2px !important;
    cursor: pointer;
  }
  
  .layout-height {
    height: calc(100vh - 128px) !important;
    overflow: scroll !important;
  }
  
  .height-100vh {
    height: 100vh !important;
  }
  
  .cal-height-100vh {
    height: calc(100vh - 128px) !important;
  }
  
  .flex-center {
    justify-content: center !important;
    align-items: center !important;
    display: flex !important;
  }
  
  .btncreate {
    /* font-weight: 700; */
    font-size: 11px !important;
    border-radius: 30px !important;
    margin-left: 0vw !important;
    margin-right: 15px !important;
    background-image: linear-gradient(to right, rgb(66, 104, 251), rgb(113, 186, 200)) !important;
    /* width: 80px !important; */
    text-transform: none;
  }
  
  .btncancle {
    font-size: 11px !important;
    border-radius: 30px !important;
    margin-left: 0vw !important;
    margin-right: 10px !important;
    background: #ffffff !important;
    color: #4268fb !important;
    /* width: 80px !important; */
    border-style: solid !important;
    border-color: #4268fb !important;
    box-shadow: none !important;
    text-transform: none;
  }
  
  .btnclear {
    /* font-weight: 700; */
    font-size: 11px !important;
    border-radius: 30px !important;
    margin-left: 0vw !important;
    margin-right: 15px !important;
    background-image: linear-gradient(to right, #9f9f9f, #9f9f9f) !important;
    color: white !important;
    /* width: 80px !important; */
    text-transform: none;
  }
  
  /* >>>.v-text-field__details {
    display: none !important;
    flex: 1 0 auto !important;
    max-width: 100% !important;
    overflow: hidden !important;
  } */
  >>>.v-list {
    width: 100% !important;
  }
  
  .bg-white {
    background-color: white !important;
  }
  
  .card-tabs {
    background-color: rgb(253, 253, 253) !important;
    border-radius: 10px !important;
    /* margin-left: 20px !important;
    margin-right: 20px !important; */
    border-style: solid !important;
    border-color: #f1f1f2 !important;
    border-width: thin !important;
    margin-top: 5px !important;
  }
  
  .text-overflow-project {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  
  .span-detail-project {
    color: #8e8e92 !important;
    margin-left: 20px !important;
  }
  
  .card-project {
    border-radius: 10px !important;
    background-color: white !important;
    /* border-color: #dadada !important; */
    border-style: solid !important;
    border-width: thin !important;
    height: 150px !important;
    cursor: pointer !important;
  }
  
  .card-project:hover {
    border-radius: 10px !important;
    background-color: rgba(234, 234, 234, 0.23137254901960785) !important;
    border-color: rgba(234, 234, 234, 0.23137254901960785) !important;
    border-style: solid !important;
    border-width: thin !important;
    height: 150px !important;
    cursor: pointer !important;
  }
  
  .span-timestamp {
    font-size: 14px !important;
    color: grey !important;
  }
  
  >>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
  }
  
  .CSChatThai {
    font-family: 'CS ChatThaiUI' !important;
    word-wrap: break-word;
  }
  
  .text-transform {
    /* text-transform: uppercase; */
    text-transform: capitalize !important;
  }
  
  .btn-plus-user {
    background-color: #efefef !important;
    color: #1d1d1d !important;
    box-shadow: none !important;
  }
  
  .font-size18 {
    font-size: 18px !important;
  }
  
  .font-title-task {
    font-size: 19px !important;
    font-weight: 500 !important;
  }
  
  /* >>>.v-list__tile .theme--light {
    height: 200px !important;
  } */
  /* >>>.v-navigation-drawer .v-list .v-list__tile {
    height: 200px !important;
    transition: none !important;
    font-weight: 500 !important;
  } */
  .card-task-pri1 {
    background-color: white !important;
    color: black !important;
    border-style: solid !important;
    border-radius: 10px !important;
    border-width: thin !important;
    /* margin-bottom: 15px; */
    /* border-color: #1b232d; */
    margin-top: 10px !important;
    margin-left: 5px !important;
    margin-right: 5px !important;
    border-left-color: #b3493d !important;
    border-left-width: 12px !important;
    /* border-left-style: solid; */
    height: 100px !important;
    cursor: pointer !important;
  }
  
  .card-task-pri2 {
    background-color: white !important;
    color: black !important;
    border-style: solid !important;
    border-radius: 10px !important;
    border-width: thin !important;
    /* margin-bottom: 15px; */
    /* border-color: #1b232d; */
    margin-top: 10px !important;
    margin-left: 5px !important;
    margin-right: 5px !important;
    border-left-color: #fcbe55 !important;
    border-left-width: 12px !important;
    /* border-left-style: solid; */
    height: 100px !important;
    cursor: pointer !important;
  }
  
  .card-task-pri3 {
    background-color: white !important;
    color: black !important;
    border-style: solid !important;
    border-radius: 10px !important;
    border-width: thin !important;
    /* margin-bottom: 15px; */
    /* border-color: #1b232d; */
    margin-top: 10px !important;
    margin-left: 5px !important;
    margin-right: 5px !important;
    border-left-color: #a0a1a3 !important;
    border-left-width: 12px !important;
    /* border-left-style: solid; */
    height: 100px !important;
    cursor: pointer !important;
  }
  
  .overflow-scroll {
    overflow-y: scroll !important;
  }
  
  .object-fit-img {
    object-fit: cover;
    object-position: 50% 0;
  }
  
  .border-img {
    border-color: grey !important;
    border-style: solid !important;
    border-width: thin !important;
  }
  
  .margin-top-120px {
    margin-top: 120px !important;
  }
  
  .text-overflow {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    width: 250px !important;
    text-align: center !important;
  }
  
  .text-overflow-groupname {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    width: 180px !important;
    /* text-align: center !important; */
  }
  
  .text-overflow-list {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    width: 190px !important;
  }
  
  .color-white {
    color: white !important;
  }
  
  /* >>>.v-list__tile__content {
    height: 70vh;
    margin-top: 50px;
  } */
  .height-200px {
    height: 200px !important;
  }
  
  .height-300px {
    height: 300px !important;
  }
  
  .width-100 {
    width: 100% !important;
  }
  
  .color-card-task {
    overflow: scroll !important;
    height: 60vh !important;
    margin-top: 20px !important;
    border-radius: 6px !important;
    background-color: #f1f1f1 !important;
  }
  
  .system-bar {
    height: 4px !important;
    background-color: #e0e0e0 !important;
    border-radius: 10px !important;
    /* margin-left: 18px !important; */
  }
  
  .font-size-16 {
    font-size: 16px !important;
  }
  
  .ml-50 {
    margin-left: 50px !important;
  }
  
  .span-clear-filter {
    color: #949494 !important;
    font-size: 16px !important;
  }
  
  >>>.v-input__slot {
    border-radius: 13px !important;
    box-shadow: none !important;
    /* background-color: rgba(142, 142, 147, 0.12156862745098039) !important; */
  }
  
  >>>.v-text-field>.v-input__control>.v-input__slot {
    cursor: text !important;
    transition: background .3s cubic-bezier(.25, .8, .5, 1) !important;
    background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
  }
  
  >>>.theme--dark.v-label {
    color: rgba(0, 0, 0, .54) !important;
  }
  
  /* >>>.theme--dark.v-icon {
      color: rgb(35, 43, 53) !important;
  } */
  >>>.theme--dark.v-input:not(.v-input--is-disabled) input {
    color: rgba(0, 0, 0, .54) !important;
  }
  
  .btn-filter-task {
    border-radius: 6px !important;
    border: solid 1px #2562af !important;
    color: #2562af !important;
    background-color: white !important;
    box-shadow: none !important;
  }
  
  .icon-filter-task {
    color: #2562af !important;
    font-size: 16px !important;
  }
  
  .icon-create-task {
    color: white !important;
    font-size: 16px !important;
  }
  
  .btn-create-task {
    background-color: #2561b0 !important;
    /* border-color: #2561b0 !important; */
    border-style: solid !important;
    border-radius: 6px !important;
    color: white !important;
    box-shadow: none !important;
  }
  
  .btn-nav {
    background-color: #d8d8d8 !important;
  }
  
  >>>.v-list .v-list--dense .theme--light {
    margin-top: 70px !important;
  }
  
  .bg-flex-1 {
    background-color: #1b232d;
  }
  
  .container {
    padding: 0px !important;
  }
  
  .fixed-content {
    min-height: 100%;
    /*position:fixed;*/
    overflow-y: scroll;
    overflow-x: hidden;
  }
  
  .content {
    padding: 0px 0px 0px !important;
  }
  
  >>>.chatboxnonselect {
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color: white;
    overflow-y: hidden;
  }
  
  .btn-color {
    background-color: white !important;
    border-color: #2561b0 !important;
    border-style: solid !important;
    border-radius: 6px !important;
    color: #2561b0 !important;
    box-shadow: none !important;
  }
  
  .icon-color {
    color: #2561b0 !important;
  }
  
  >>>.theme--light.v-card {
    background-color: #fff;
    border-color: none !important;
    color: rgba(0, 0, 0, .87);
  }
  
  .textWrap {
    white-space: nowrap;
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    /* text-align: center; */
  }
  </style>
  